import React from "react";
import Bradcom from "./Utils/Bradcom";
import TeamMember from "./Utils/TeamMember";

import teamMember1photo1 from "../assets/img/team/krzysztofPhoto.jpg";
import teamMember1photo2 from "../assets/img/team/teamMember1photo2.jpg";
import teamMember1photo3 from "../assets/img/team/teamMember1photo3.jpg";

import teamMember2photo1 from "../assets/img/team/kasiaPhoto.jpg";
import teamMember2photo2 from "../assets/img/team/teamMember2photo2.jpg";
import teamMember2photo3 from "../assets/img/team/teamMember2photo3.jpg";

import teamMember3photo1 from "../assets/img/team/stefanPhoto.jpg";

export default function Main() {
  return (
    <>
      <main>
        <Bradcom
          title={"Team Details"}
          subtitle={"Home"}
          newtitle={"Team Details"}
        />
        <div className="container pt-5 pb-5">
          <div className="col text-center">
            <h6 className="display-6">
              Głodnych Turystów pysznie nakarmi Pan Krzysztof i Pani Kasia.
              Wszystkie sprawy organizacyjne załatwi Pan Stefan.
            </h6>
          </div>
        </div>
        <p></p>
        <TeamMember
          name={"Krzysztof"}
          // email={"foo@foo.com"}
          image1={teamMember1photo1}
          // image2={teamMember1photo2}
          // image3={teamMember1photo3}
          withPaddingBottom={false}
          withPaddingTop={false}
        >
          <p className="pt-2 pt-lg-0">
            Kuchnia to zdecydowanie Jego miejsce! Ze smacznym posiłkiem jest
            podobnie jak z jednym zdjęciem -zastępuje tysiąc słów.
          </p>
        </TeamMember>
        <TeamMember
          name={"Kasia"}
          // email={"foo@gmail.com"}
          image1={teamMember2photo1}
          // image2={teamMember2photo2}
          // image3={teamMember2photo3}
          withPaddingBottom={false}
          withPaddingTop={true}
        >
          <p className="pt-2 pt-lg-0">
            Czystość w Słonecznym Podgórzu zawdzięczamy Pani Kasi. Dzięki jej
            energii i doświadczeniu oferujemy naszym Gościom właściwe standardy.
          </p>
        </TeamMember>
        <TeamMember
          name={"Stefan"}
          // email={"foo@gmail.com"}
          image1={teamMember3photo1}
          // image2={teamMember2photo2}
          // image3={teamMember2photo3}
          withPaddingBottom={true}
          withPaddingTop={true}
        >
          <p className="pt-2 pt-lg-0">
            Gdy jesteś w nowym miejscu, to potrzebujesz czas aby się z nim
            oswoić. Pan Stefan sprawi, że ten krok zrobisz w mig. Zna doskonale
            okolicę i wie czego potrzebują turyści aby dobrze odpocząć.
          </p>
        </TeamMember>
      </main>
    </>
  );
}
